// extracted by mini-css-extract-plugin
export default {"row":"billing_row__hCFkO","wrapper":"billing_wrapper__m6TNv","loader":"billing_loader__5QII3","col":"billing_col__EIB56","card":"billing_card__4ufs6"};